// Lip landmark indices from MediaPipe FaceLandmarker's 478-point topology.
// These traverse the outer lip edge and the inner mouth boundary so we can
// draw a filled polygon (outer contour minus inner cavity) for the colour
// overlay.
//
// Reference: https://github.com/google-ai-edge/mediapipe/blob/master/mediapipe/python/solutions/face_mesh_connections.py
// The ordering below walks each contour in a stable winding direction,
// which matters for Canvas 2D's even-odd fill rule.

export const OUTER_LIP_INDICES: readonly number[] = [
  61, 185, 40, 39, 37, 0, 267, 269, 270, 409,
  291, 375, 321, 405, 314, 17, 84, 181, 91, 146
];

export const INNER_LIP_INDICES: readonly number[] = [
  78, 191, 80, 81, 82, 13, 312, 311, 310, 415,
  308, 324, 318, 402, 317, 14, 87, 178, 88, 95
];

// Landmarks that must be rendered as sharp corners (no smoothing).
// The four mouth commissure landmarks — outer-left (61), outer-right (291),
// inner-left (78), inner-right (308). Making these sharp forces the filled
// path to pass exactly through each landmark, giving clean closure at the
// mouth corners on BOTH the outer and inner polygons. Without it the
// inner polygon's Chaikin smoothing rounds the landmarks inward, so the
// upper/lower-lip junction line loses its natural upward tilt toward the
// corner and the rendered result looks "cut off" there.
//
// The cupid's-bow anchors (37, 0, 267) are intentionally NOT sharp:
// three consecutive lineTos rendered the upper lip as a polygonal V that
// read as artificial. Chaikin smoothing + negative cupidsBowLift
// compensation recovers the native dip depth with a smooth profile.
export const SHARP_LIP_LANDMARKS: ReadonlySet<number> = new Set([
  61, 291, 78, 308
]);
